import React from "react";
import styles from "./Page.module.scss";

const Page = ({ children }) => {
  return (
    <div id={"page"} className={styles.page}>
      {typeof children === "string" ? (
        <div
          className={styles.string}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

export default Page;
